import { defineMessages } from 'react-intl';

export default defineMessages({
  notice: {
    id: 'view.component.RefundConfirmationModal.notice',
    defaultMessage:
      'To refund your Customer, please go to your marketplace account',
  },
  title: {
    id: 'view.component.RefundConfirmationModal.title',
    defaultMessage: 'Status update',
  },
  mainCondition: {
    id: 'view.component.RefundConfirmationModal.mainCondition',
    defaultMessage:
      'I confirm that the refund was successfully done through the marketplace',
  },
  secondaryCondition: {
    id: 'view.component.RefundConfirmationModal.secondaryCondition',
    defaultMessage:
      'Once you click "Next" your Customer will receive an automatic notification confirming his refund.',
  },
  referenceMessage: {
    id: 'view.component.RefundConfirmationModal.referenceMessage',
    defaultMessage:
      'Refunds must be made directly on {marketPlace} by <link>clicking here.</link>',
  },
  referenceMessageNoLink: {
    id: 'view.component.RefundConfirmationModal.referenceMessageNoLink',
    defaultMessage: 'Refunds must be made directly on {marketPlace}',
  },
  instructionMessage: {
    id: 'view.component.RefundConfirmationModal.instructionMessage',
    defaultMessage: `
    <strong>Once the refunds have been made,</strong> inform the customer by ticking the box and clicking on "Next".
    `,
  },
  confirmationMessage: {
    id: 'view.component.RefundConfirmationModal.confirmationMessage',
    defaultMessage:
      'You confirm that you have made the refunds on {marketPlace}.',
  },
  confirmationMessageNoMarketplace: {
    id: 'view.component.RefundConfirmationModal.confirmationMessageNoMarketplace',
    defaultMessage: 'You confirm that you have made the refund(s)',
  },
  amountRefunded: {
    id: 'view.component.productInfo.amountRefunded',
    defaultMessage: 'Amount to refund (VAT incl)',
  },
  comment: {
    id: 'view.component.block.popin.note',
    defaultMessage:
      "This comment will be only visible to the Seller. The Customer won't see it.",
  },
  orderNumber: {
    id: 'view.RefundForm.orderNumber',
    defaultMessage: 'Order number: {orderReference}',
  },
  commentRefund: {
    id: 'view.component.block.actionsOnTheFolder.comment',
    defaultMessage: 'Commentaire',
  },
  RequestedAmountGreaterThanPrice: {
    id: 'Reverse.Marketplace.Errors.Refunds.RequestedAmountGreaterThanPrice',
    defaultMessage: 'The requested refund amount is greater than product price',
  },
  RequestedAmountNegative: {
    id: 'Reverse.Marketplace.Errors.Refunds.RequestedAmountNegative',
    defaultMessage: 'The requested refund amount must be greater than 0',
  },
  RequestedAmountWithAlreadyRefundedGreaterThanPrice: {
    id: 'Reverse.Marketplace.Errors.Refunds.RequestedAmountWithAlreadyRefundedGreaterThanPrice',
    defaultMessage:
      'The sum of former refunds and the requested refund amount is greater than product price',
  },
  update: {
    id: 'view.component.updateStatus.actionDefault',
    defaultMessage: 'Update',
  },
  success: {
    id: 'view.component.RefundConfirmationModal.success',
    defaultMessage: 'Your refund was registered!',
  },
  vatIncludedPlaceholder: {
    id: 'view.RefundForm.amountSuffix',
    defaultMessage: '{currency} VAT incl.',
  },
  refundByWireTransfer: {
    id: 'view.component.commercialSolution.refundByWireTransfer',
    defaultMessage: 'Refund by wire transfert',
  },
  refundOnPaymentMethod: {
    id: 'view.component.commercialSolution.refundOnPaymentMethod',
    defaultMessage: 'Refund on payment method',
  },
  giftCard: {
    id: 'view.component.commercialSolution.giftCard',
    defaultMessage: 'Gift card',
  },
  voucher: {
    id: 'view.component.commercialSolution.voucher',
    defaultMessage: 'Voucher',
  },
  exchangeOnSellerStock: {
    id: 'view.component.commercialSolution.exchangeOnSellerStock',
    defaultMessage: 'Exchange on seller stock',
  },
  creditNote: {
    id: 'view.component.commercialSolution.creditNote',
    defaultMessage: 'Credit note',
  },
  check: {
    id: 'view.component.commercialSolution.check',
    defaultMessage: 'Check',
  },
  digitalGiftCard: {
    id: 'view.component.commercialSolution.digitalGiftCard',
    defaultMessage: 'Digital gift card',
  },
  lender: {
    id: 'view.component.commercialSolution.lender',
    defaultMessage: 'Lender',
  },
  loyaltyCard: {
    id: 'view.component.commercialSolution.loyaltyCard',
    defaultMessage: 'Loyalty card',
  },
  paymentService: {
    id: 'view.component.commercialSolution.paymentService',
    defaultMessage: 'Payement service',
  },
  commercialSolutionLabelType: {
    id: 'view.component.refundConfirmationModal.commercialSolutionLabelType',
    defaultMessage: 'Commercial solution type',
  },
  cashRegister: {
    id: 'view.card.accounting.CashRegister',
    defaultMessage: 'Cash register',
  },
  loading: { id: 'global.loading', defaultMessage: 'Loading...' },
  integratedProvider: {
    id: 'view.component.commercialSolution.integratedProvider',
    defaultMessage: 'Integrated provider',
  },
  other: {
    id: 'view.component.commercialSolution.other',
    defaultMessage: 'Other',
  },
  notSet: {
    id: 'view.component.commercialSolution.notSet',
    defaultMessage: 'Not set',
  },
  wireTransfer: {
    id: 'view.component.commercialSolution.wireTransfer',
    defaultMessage: 'Wire transfert',
  },
});
